import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Components
import ServicesList from './ServicesList';

// Actions
import {
  addService,
  removeService,
  removePackageService
} from 'store/reducers/appointment/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';
import { updateReadOnlyServices } from 'store/reducers/service/actions';

// Selectors
import {
  getServices,
  getPackageServices
} from 'store/reducers/appointment/selectors';
import {
  getIsQuoteAppt,
  getReadOnlyServices
} from 'store/reducers/quoteAppt/selectors';

const mapStateToProps = state => ({
  services: getServices(state),
  packageServices: getPackageServices(state),
  isQuoteAppt: getIsQuoteAppt(state),
  readOnlyServices: getReadOnlyServices(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addService,
      removeService,
      removePackageService,
      gtmUserEvent,
      updateReadOnlyServices
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServicesList);



// WEBPACK FOOTER //
// ./src/components/molecules/ServicesList/ServicesListContainer.js